import { styled } from "@pigment-css/react";
import { ChevronRightThin } from "@acto/web-common/components";
import {
  RowBody,
  RowButton,
  RowChevron,
  RowItem,
  RowList,
  RowMeta,
  RowTitle,
} from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { MEETING_PREP_ROW_PADDING_BLOCK } from "./rowPrimitives";

const EntryList = styled(RowList)(({ theme }) => ({
  gap: theme.fieldSalesTwo.spacing[MEETING_PREP_ROW_PADDING_BLOCK],
}));

const EntryItem = styled(RowItem)(({ theme }) => ({
  paddingTop: theme.fieldSalesTwo.spacing[MEETING_PREP_ROW_PADDING_BLOCK],
}));

const EntryButton = styled(RowButton)(({ theme }) => ({
  gap: theme.fieldSalesTwo.spacing[12],
}));

const EntryBody = styled(RowBody)({ gap: 0 });

const EntryMeta = styled(RowMeta)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export interface Entry {
  title: string;
  meta: string;
  onOpen: () => void;
}

export function EntryRows({ entries }: { entries: Entry[] }) {
  return (
    <EntryList role="list">
      {entries.map((entry) => (
        <EntryItem key={entry.title}>
          <EntryButton type="button" onClick={entry.onOpen}>
            <EntryBody>
              <RowTitle>{entry.title}</RowTitle>
              <EntryMeta>{entry.meta}</EntryMeta>
            </EntryBody>
            <RowChevron>
              <ChevronRightThin strokeWidth={2} />
            </RowChevron>
          </EntryButton>
        </EntryItem>
      ))}
    </EntryList>
  );
}
